import Card from '@mui/material/Card';
import useMediaQuery from '@mui/material/useMediaQuery';
import { withStyles } from 'tss-react/mui';
import { supportsPassiveEvents } from 'detect-it';
import React, { useEffect, useState } from 'react';
import shadow from '../../helpers/shadow';
import VoteSlider from './VoteSlider';
import ChatbotButton from 'components/Chatbot/ChatbotButton';

const styles = () => ({
  relative: {
    borderRadius: 12,
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
    marginTop: '-40px',
    boxShadow: shadow.lg,
  },
  fixed: {
    borderRadius: 0,
    boxShadow: shadow.lg,
  },
  mobileFixed: {
    borderRadius: 0,
    paddingBottom: 55,
    boxShadow: shadow.lg,
  },
});

const StickyVoteSlider = props => {
  const [opacity, setOpacity] = useState(props.isRelative ? 1 : 0);
  const [votePos, setVotePos] = useState('relative');

  const isMobileView = useMediaQuery('(max-width: 991px)');

  const listenScrollEvent = () => {
    const post = document.getElementById('post');
    const voteOffset = post.clientHeight - 123;
    if (window.scrollY > 500) {
      setOpacity(1);
    } else {
      setOpacity(0);
    }
    if (window.scrollY > voteOffset) {
      setVotePos('relative');
    } else {
      setVotePos('fixed');
    }
  };

  useEffect(() => {
    if (!props.isRelative)
      window.addEventListener(
        'scroll',
        listenScrollEvent,
        // better scroll performance: https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
        supportsPassiveEvents ? { passive: true } : false,
      );
    return () => {
      window.removeEventListener('scroll', listenScrollEvent);
    };
  }, [props]);

  const { classes } = props;

  let cardPos = isMobileView ? classes.mobileFixed : classes.fixed;
  if (votePos === 'relative') cardPos = classes.relative;

  const voteCard = (
    <Card className={cardPos}>
      <VoteSlider
        author={props.author}
        permlink={props.permlink}
        id={props.id}
        title={props.title}
        smiles={props.smiles}
        totalSmiles={props.totalSmiles}
        noOfComments={props.noOfComments}
        depth={props.depth}
        onCommentAdd={props.onCommentAdd}
        noDivider
        mode="sticky"
      />
    </Card>
  );

  if (props.isRelative) return <div className="pt-3">{voteCard}</div>;

  return (
    <>
      {opacity !== 0 && (
        <ChatbotButton
          location={props.locationTitle}
          showSpeechBubble={!!props.locationTitle}
          largerBottomMargin
          chatOpen={props.chatOpen}
        />
      )}
      <div
        style={{
          position: votePos,
          bottom: 0,
          right: 0,
          width: '100%',
          zIndex: '1000',
          opacity,
          transition: 'opacity 0.1s linear',
        }}
        className="safebottom"
      >
        <div className="container-fluid p-0">
          <div className="row justify-content-center no-gutters">
            <div className="col-xl-1 col-0" />
            <div className="col-xl-8 col-lg-8 col-md-11 col-sm-11 col-12 d-flex justify-content-end">
              <div className="scaleWidth">{voteCard}</div>
            </div>
            <div className="col-xl-3 col-lg-4 d-none d-xl-block d-lg-block pb-4" />
          </div>
        </div>
      </div>
      <style jsx>{`
        .scaleWidth {
          width: 100%;
        }
        @media (min-width: 1500px) {
          .scaleWidth {
            width: 85%;
          }
        }
        @media (min-width: 1700px) {
          .scaleWidth {
            width: 75%;
          }
        }
      `}</style>
    </>
  );
};

export default withStyles(StickyVoteSlider, styles);
